import { UserGroup } from "@/store/user-management/types";

export interface MobileRaiseTemplate {
	mobileRaiseTemplateID: number;
	title: string;
	userGroupIDs: number[];
	gridSet: number;
	mobileRaiseLinks: MobileRaiseLink[];
}

export interface TemplateGridRowModel {
	mobileRaiseTemplateID: number;
	title: string;
	quickSelectRaises: string;
	userGroups: string[];
}

export interface TemplateDetailsModel {
	mobileRaiseTemplateID?: number;
	title: string;
	userGroups: UserGroup[];
	quickSelectRaises: number;
	mobileRaiseLinks: MobileRaiseLinkEditModel[];
}

export interface IconSet {
	iconSetID: number;
	title: string;
	// FontAwesome CSS class
	iconData: string;
	objectID: number | null;
	manualRaiseType: MobileRaiseType | null;
}

export interface RaiseId {
	objectID: number;
	manualRaiseType: MobileRaiseType;
}

export interface MobileRaiseLink {
	objectID: number;
	manualRaiseType: MobileRaiseType;
	gridSetSlot: number | null;
	iconSetID: number | null;
}

export interface MobileRaiseLinkEditModel {
	objectID: number;
	manualRaiseType: MobileRaiseType;
	titleList: string[];
	gridSetSlot: number | null;
	iconSetID: number | null;
}

export interface MobileRaiseLinksEditModel {
	gridSet: number;
	links: MobileRaiseLinkEditModel[];
}

export interface MobileRaiseTemplateEditModel {
	mobileRaiseTemplateID: number;
	title: string;
	gridSet: number;
	userGroups: UserGroup[];
	mobileRaiseLinks: MobileRaiseLinksEditModel;
}

export interface MobileRaise {
	objectID: number;
	manualRaiseType: MobileRaiseType;
	titleList: string[];
}

export interface LinksSelectorRow extends MobileRaiseLinkEditModel {
	displayType: string;
	iconSetTitle: string;
	addedToTemplate: boolean;
}

export interface MobileRaiseProjection {
	objectID: number;
	manualRaiseType: MobileRaiseType;
	iconData: string | null;
	gridSetSlot: number | null;
	titleList: string[];
}

export interface MobileRaiseTemplateProjection {
	mobileRaiseTemplateID: number;
	title: string;
	raises: MobileRaiseProjection[];
}

export interface MobileRaiseState {
	mobileRaiseTemplates: MobileRaiseTemplate[];
	mobileRaises: MobileRaise[];
	iconSets: IconSet[];
	templateProjections: MobileRaiseTemplateProjection[];
	currentTemplateProjectionIdx: number;
	lastUsedTemplateId: number | null;
	isProjectionsLoaded: boolean;
}

export enum MobileRaiseType {
	ManualRaise = 1,
	ActivityLog = 2,
	AssessmentTour = 3
}
